import React from "react";

import {
  Stat,
  StatLabel,
  StatNumber,
  useBreakpointValue,
  StatProps,
  Skeleton,
} from "@chakra-ui/react";

import { mobileStyleBreakpoint } from "util/styleHelpers";
import { MobileOnly } from "./BreakpointVisibility";
import { ErrorLoadingInline } from "./ErrorLoading";

const desktopRightAlign = mobileStyleBreakpoint<string | undefined>(
  undefined,
  "rightAlign"
);

const ContractStat = ({
  size,
  label,
  isLoaded = true,
  isError = false,
  labelMobileOnly = false,
  desktopRightAligned = false,
  children,
  ...rest
}: React.PropsWithChildren<
  {
    size?: string;
    label?: string | React.ReactNode;
    isLoaded?: boolean;
    isError?: boolean;
    labelMobileOnly?: boolean;
    desktopRightAligned?: boolean;
  } & StatProps
>): React.ReactElement => {
  const variant = useBreakpointValue(
    desktopRightAligned ? desktopRightAlign : {}
  );

  const _label =
    typeof label === "string" ? (
      <StatLabel whiteSpace="nowrap" mb={0}>
        {label}
      </StatLabel>
    ) : (
      label
    );

  const statContent = isLoaded ? children : "Loading";

  return (
    <Stat size={size} variant={variant} {...rest}>
      {labelMobileOnly ? <MobileOnly>{_label}</MobileOnly> : _label}
      <Skeleton isLoaded={isLoaded || isError}>
        {isError ? (
          <ErrorLoadingInline />
        ) : (
          <StatNumber>{statContent}</StatNumber>
        )}
      </Skeleton>
    </Stat>
  );
};

export default ContractStat;
